/**
 * Enum for Constant values
 * @enum {Constants}
 */
export const WEB_RTC_Constants = {

    // video call related constants
    CALL_STATE: "cls",
    VIDEO_AUDIO_CALL_INVITATION: "voc",
    CALL_STATE_VIDEO_INVITE: 1,
    CALL_STATE_VOICE_INVITE: 2,
    ROOM_JOINED: "joined",
    RTC_ERROR: "error",
    UNREAD_COUNT: "urc",
    AGENT_VIDEO_ERROR: "agentVideoError",
    AGENT_VIDEO_PUBISHED: "agentVideoPublished",
    LOCAL_AUDIO_ERROR: "localAudioError",
    LOCAL_VIDEO_ERROR: "localVideoError",
    CUSTOMER_VIDEO_PUBISHED: "localVideoPublished",
    ENABLED_CUSTOMER_CAMERA: "customerCameraEnabled",
    ENABLED_VOICE_ONLY_CALL: "voiceOnlyCall",
    END_CALL_BUTTON_TEXT: "Switch to Chat",
    CALL_ERROR_TEXT: "An error occurred during joining audio or video call, please try again later.",
    UNSUPPORTED_DEVICE_TEXT: "You may have selected an unsupported audio or video source, please select an appropriate media source from device settings.",
    AGENT_ALIAS_TEXT: "A",
    DEVICE_SETTINGS_CONTINUE_BTN_TEXT: "continue",
    CALL_TRANSFER_TEXT: "Transferring to agent ...",
    VIDEO_CALL_HEADING: "Connect with us over video",
    VOICE_ONLY_CALL_HEADING: "Connect with us over voice-only",
    VIDEO_CALL_DEVICE_SETTINGS_FINAL_TEXT: "Great! you should be all ready to share your video and audio with our agent. Click the button below when you're ready to chat.",
    VOICE_ONLY_CALL_DEVICE_SETTINGS_FINAL_TEXT: "Great! you should be all ready to share your audio with our agent. Click the button below when you're ready to chat.",
    VIDEO_CALL_CHECK_DEVICES_BUTTON_TEXT: "Check Audio & Video settings",
    VOICE_ONLY_CALL_CHECK_DEVICES_TEXT: "Check Audio settings",
    VIDEO_CALL_START_BUTTON_TEXT: "Start Video Call",
    VOICE_ONLY_CALL_START_BUTTON_TEXT: "Start Voice Call",
    PRE_VIDEO_CALL_PRIMARY_TEXT: "For the best video call experience, let's check your camera and audio settings before connecting.",
    PRE_VOICE_CALL_PRIMARY_TEXT: "For the best voice call experience, let's check your audio settings before connecting.",
    PRE_VIDEO_CALL_SECONDARY_TEXT: "If this your first time joining from this computer, your browser will ask permission to access the camera and microphone.",
    PRE_VOICE_CALL_SECONDARY_TEXT: "If this your first time joining from this computer, your browser will ask permission to access the microphone.",
    VIDEO_CALL_DEVICE_SETTINGS_PRIMARY_TEXT: "After allowing your browser to access devices (via the browser pop-up), check your settings below.",
    VOICE_CALL_DEVICE_SETTINGS_PRIMARY_TEXT: "After allowing your browser to access devices (via the browser pop-up), check your settings below.",
    VIDEO_CALL_DEVICE_SETTINGS_SECONDARY_TEXT: `If you didn't get the browser pop-up and/or can't see your camera view in the box below,
        <a href=\"https://www.nuance.com/about-us/company-policies/privacy-policies.html\" target=\"_new\">try these steps</a>.`,
    VOICE_CALL_DEVICE_SETTINGS_SECONDARY_TEXT: `If you didn't get the browser pop-up and/or can't see your microphone in the box below,
        <a href=\"https://www.nuance.com/about-us/company-policies/privacy-policies.html\" target=\"_new\">try these steps</a>.`,
    BROWSER_SETTINGS_POPUP_TEXT: "Allow this site to use your camera and microphone?",
    BROWSER_SETTINGS_POPUP_VOICE_TEXT: "Allow this site to use your microphone?",
    DISCLAIIMER_TEXT: "Your call may be monitored and recorded for quality purposes. By initiating call with us you are agreeing to our <a href=\"https://www.nuance.com/about-us/company-policies/privacy-policies.html\" target=\"_new\">Terms & Conditions</a>.",
};

export const DVV_CALL_TYPE = {
    VIDEO_CALL_ONE_WAY: "VoiceVideoAgentOnly",
    VIDEO_CALL_TWO_WAY: "VoiceVideo2way",
    VOICE_ONLY: "Voice",
};

export const DVV_EVENT_TYPE = {
    CUSTOMER_ACCEPTED_CALL_OFFER: "dvvOfferAccepted",
    CUSTOMER_DECLINED_CALL: "dvvOfferDeclined",
    CUSTOMER_FAILED_CALL: "dvvCustomerFailed",
    CUSTOMER_REQUESTED_CALL: "dvvCustomerRequestedCall",
};
